// src/pages/noivos/Noivos.js

import React, { useEffect, useState } from 'react';
import { getTurmasNoivos, createInscricaoNoivos } from '../../services/api';
import { maskPhone, formatDate } from '../../utils/helpers';
import FileUpload from '../../components/forms/FileUpload';
import Toast from '../../components/common/Toast';
import { uploadArquivo } from '../../services/uploadHelper';
import noivosIcon from '../../assets/noivos_icon.png';



const parseDate = (dateStr) => {
  if (!dateStr) return null;
  let s = String(dateStr).trim();
  if (s.includes('T')) s = s.split('T')[0];
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [d, m, y] = s.split('/');
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  return null;
};

const addDays = (date, n) => {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
};

const calcAberta = (turmas) => {
  if (!turmas || turmas.length === 0) return { aberta: false, turma: null };
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const sorted = [...turmas].sort((a, b) => {
    const da = parseDate(a.dataInicio);
    const db = parseDate(b.dataInicio);
    return (da || 0) - (db || 0);
  });

  for (let i = 0; i < sorted.length; i++) {
    const atual = sorted[i];
    const inicioAtual = parseDate(atual.dataInicio);
    const anterior = i > 0 ? sorted[i - 1] : null;
    const inicioAnterior = anterior ? parseDate(anterior.dataInicio) : null;
    if (!inicioAtual) continue;

    const abreEm = anterior && inicioAnterior ? addDays(inicioAnterior, 1) : null;
    const fechaEm = addDays(inicioAtual, -4);

    const abertaApos = !anterior || !abreEm || hoje >= abreEm;
    const abertaAntes = hoje <= fechaEm;

    if (abertaApos && abertaAntes) {
      const diasRestantes = Math.ceil((fechaEm - hoje) / (1000 * 60 * 60 * 24));
      return { aberta: true, turma: atual, diasRestantes };
    }
  }
  return { aberta: false, turma: null };
};

const initialForm = {
  nomeNoivo: '', enderecoNoivo: '', telefoneNoivo: '', comunhaoNoivo: '',
  nomeNoiva: '', enderecoNoiva: '', telefoneNoiva: '', comunhaoNoiva: '',
  dataCasamento: '',
};

const Noivos = () => {
  const [turmas, setTurmas] = useState([]);
  const [loadingTurmas, setLoadingTurmas] = useState(true);
  const [inscrInfo, setInscrInfo] = useState({ aberta: false, turma: null });
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [files, setFiles] = useState({});
  const [toast, setToast] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTurmasNoivos()
      .then(r => {
        const t = r?.data || [];
        setTurmas(t);
        setInscrInfo(calcAberta(t));
      })
      .catch(() => {})
      .finally(() => setLoadingTurmas(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let v = value;
    if (name === 'telefoneNoivo' || name === 'telefoneNoiva') v = maskPhone(value);
    setForm(f => ({ ...f, [name]: v }));
    setErrors(err => ({ ...err, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.nomeNoivo.trim())    errs.nomeNoivo    = 'Obrigatório.';
    if (!form.enderecoNoivo.trim()) errs.enderecoNoivo = 'Obrigatório.';
    if (!form.telefoneNoivo.trim()) errs.telefoneNoivo = 'Obrigatório.';
    if (!form.comunhaoNoivo)       errs.comunhaoNoivo = 'Selecione.';
    if (!form.nomeNoiva.trim())    errs.nomeNoiva    = 'Obrigatório.';
    if (!form.enderecoNoiva.trim()) errs.enderecoNoiva = 'Obrigatório.';
    if (!form.telefoneNoiva.trim()) errs.telefoneNoiva = 'Obrigatório.';
    if (!form.comunhaoNoiva)       errs.comunhaoNoiva = 'Selecione.';
    if (!files.docNoivo)           errs.docNoivo     = 'Documento do noivo obrigatório.';
    if (!files.docNoiva)           errs.docNoiva     = 'Documento da noiva obrigatório.';
    if (!files.comprovante)        errs.comprovante  = 'Comprovante obrigatório.';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
setLoading(true);
    try {
      const turmaNome = (inscrInfo.turma?.nome || 'Turma').replace(/\s+/g, '_');
      const pastaBase = `noivos/${turmaNome}`;
 
      // Upload direto para o Hostgator
      const urlDocNoivo    = files.docNoivo
        ? await uploadArquivo(files.docNoivo, `${pastaBase}/documentos`) : '';
      const urlDocNoiva    = files.docNoiva
        ? await uploadArquivo(files.docNoiva, `${pastaBase}/documentos`) : '';
      const urlComprovante = files.comprovante
        ? await uploadArquivo(files.comprovante, `${pastaBase}/comprovantes`) : '';
 
      // Envia só as URLs para o GAS
      const dados = {
        turmaId:     inscrInfo.turma?.id || '',
        turmaNome:   inscrInfo.turma?.nome || '',
        ...form,
        urlDocNoivo,
        urlDocNoiva,
        urlComprovante,
      };
 
      const res = await createInscricaoNoivos(dados);
      if (res?.success) {
        setSubmitted(true);
        setForm(initialForm);
        setFiles({});
      } else {
        setToast({ msg: res?.message || 'Erro ao enviar inscrição.', type: 'error' });
      }
    } catch {
      setToast({ msg: 'Erro de conexão. Tente novamente.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <main style={{ paddingTop: '72px' }}>
        <section style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-3xl) var(--space-xl)' }}>
          <div style={{ textAlign: 'center', maxWidth: 520 }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>💍</div>
            <h2 style={{ marginBottom: '1rem' }}>Inscrição Realizada!</h2>
            <p style={{ marginBottom: '2rem' }}>Inscrição confirmada para o Curso de Noivos. Compareça, no dia do curso, ao Salão Paroquial (Ao lado da Igreja Matriz) Às 7:30.</p>
            <button className="btn btn-primary btn-lg" onClick={() => setSubmitted(false)}>Nova Inscrição</button>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main style={{ paddingTop: '72px' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, var(--navy-dark) 0%, var(--navy) 100%)',
        padding: 'var(--space-2xl) var(--space-xl)',
        textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>Sacramento</div>
          <img src={noivosIcon} alt="Noivos" style={{ width: 80, marginBottom: '0.5rem', filter: 'invert(1)', opacity: 0.9 }} />
          <h1 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Curso de Noivos</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 560, margin: '0 auto', lineHeight: 1.8 }}>
            Preparação espiritual e prática para o Sacramento do Matrimônio.
            Um momento especial para o casal crescer junto na fé.
          </p>
        </div>
      </section>

      {/* Turmas */}
      <section style={{ background: 'var(--off-white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Turmas Disponíveis</h2>
          {loadingTurmas ? (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 'var(--space-md)' }}>
              {[1, 2].map(i => (
                <div key={i} style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-lg)', borderTop: '4px solid var(--gray-200)', boxShadow: 'var(--shadow-sm)' }}>
                  <div style={{ height: 18, width: '60%', background: 'var(--gray-100)', borderRadius: 4, marginBottom: '1rem', animation: 'pulse 1.5s ease-in-out infinite' }} />
                  {[1,2].map(j => (
                    <div key={j} style={{ height: 14, background: 'var(--gray-100)', borderRadius: 4, marginBottom: '0.5rem', animation: 'pulse 1.5s ease-in-out infinite' }} />
                  ))}
                </div>
              ))}
              <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>
            </div>
          ) : turmas.length === 0 ? (
            <div className="alert alert-info" style={{ maxWidth: 600, margin: '0 auto' }}>Nenhuma turma cadastrada no momento.</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 'var(--space-md)' }}>
              {turmas.map((t, i) => (
                <div key={i} className="card" style={{ padding: 'var(--space-lg)', borderTop: '4px solid var(--gold)' }}>
                  <h3 style={{ color: 'var(--navy)', marginBottom: '0.75rem', fontSize: '1.1rem' }}>{t.nome}</h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
                      <span style={{ color: 'var(--gray-400)' }}>Início</span>
                      <strong>{formatDate(t.dataInicio)}</strong>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
                      <span style={{ color: 'var(--gray-400)' }}>Término</span>
                      <strong>{formatDate(t.dataFinal)}</strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Formulário */}
      <section style={{ background: 'var(--white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container" style={{ maxWidth: 900 }}>

          {!loadingTurmas && (!inscrInfo.aberta ? (
            <div style={{ background: 'linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%)', borderRadius: 'var(--radius-xl)', padding: 'var(--space-2xl)', textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⏳</div>
              <h3 style={{ color: 'var(--white)', marginBottom: '0.75rem' }}>Inscrições encerradas no momento</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.8 }}>
                As inscrições abrem no dia seguinte ao início da turma atual e encerram 4 dias antes do início da próxima turma.
              </p>
            </div>
          ) : (
            <>
              {/* Banner aberta */}
              <div style={{ background: 'linear-gradient(135deg, var(--success) 0%, #27ae60 100%)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-md) var(--space-xl)', marginBottom: 'var(--space-xl)', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <span style={{ fontSize: '1.5rem' }}>✅</span>
                <div>
                  <p style={{ color: 'var(--white)', fontWeight: 600, margin: 0 }}>Inscrições abertas — Turma {inscrInfo.turma?.nome}</p>
                  <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.875rem', margin: 0 }}>
                    {inscrInfo.diasRestantes > 0 ? `Encerram em ${inscrInfo.diasRestantes} dia${inscrInfo.diasRestantes > 1 ? 's' : ''}` : 'Último dia de inscrição!'}
                  </p>
                </div>
              </div>

              {/* Info do curso */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-xl)' }}>
                <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-lg)', boxShadow: 'var(--shadow-sm)', borderLeft: '4px solid var(--gold)', display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                  <span style={{ fontSize: '1.4rem', flexShrink: 0 }}>🕖</span>
                  <div>
                    <p style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--gold)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.2rem' }}>Horário</p>
                    <p style={{ fontWeight: 600, color: 'var(--navy)', fontSize: '0.95rem' }}>7:30 às 16h</p>
                  </div>
                </div>
                <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-lg)', boxShadow: 'var(--shadow-sm)', borderLeft: '4px solid var(--gold)', display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                  <span style={{ fontSize: '1.4rem', flexShrink: 0 }}>📍</span>
                  <div>
                    <p style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--gold)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.2rem' }}>Local</p>
                    <p style={{ fontWeight: 600, color: 'var(--navy)', fontSize: '0.95rem' }}>Salão Paroquial</p>
                    <p style={{ fontSize: '0.82rem', color: 'var(--gray-400)' }}>Ao lado da Igreja Matriz</p>
                  </div>
                </div>
              </div>

              <div className="form-card-mobile" style={{ background: 'var(--white)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-md)', padding: 'var(--space-2xl)' }}>
                <h2 style={{ marginBottom: '0.25rem' }}>Formulário de Inscrição</h2>
                <p style={{ marginBottom: 'var(--space-lg)' }}>Preencha os dados do casal para realizar a inscrição.</p>

                <form onSubmit={handleSubmit} noValidate>

                  {/* Noivo e Noiva lado a lado */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Dados do Casal</h4>
                  <div className="casal-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-xl)', marginBottom: 'var(--space-lg)' }}>

                    {/* Coluna Noivo */}
                    <div>
                      <p style={{ fontWeight: 700, color: 'var(--navy)', marginBottom: 'var(--space-md)', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>👤 Noivo</p>
                      <div className="form-group">
                        <label className="form-label">Nome Completo <span className="required">*</span></label>
                        <input name="nomeNoivo" value={form.nomeNoivo} onChange={handleChange}
                          className={`form-input${errors.nomeNoivo ? ' error' : ''}`} />
                        {errors.nomeNoivo && <p className="form-error">{errors.nomeNoivo}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Telefone / WhatsApp <span className="required">*</span></label>
                        <input name="telefoneNoivo" value={form.telefoneNoivo} onChange={handleChange}
                          placeholder="(85) 99000-0000"
                          className={`form-input${errors.telefoneNoivo ? ' error' : ''}`} />
                        {errors.telefoneNoivo && <p className="form-error">{errors.telefoneNoivo}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Endereço <span className="required">*</span></label>
                        <input name="enderecoNoivo" value={form.enderecoNoivo} onChange={handleChange}
                          className={`form-input${errors.enderecoNoivo ? ' error' : ''}`} />
                        {errors.enderecoNoivo && <p className="form-error">{errors.enderecoNoivo}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Possui Primeira Comunhão? <span className="required">*</span></label>
                        <select name="comunhaoNoivo" value={form.comunhaoNoivo} onChange={handleChange}
                          className={`form-select${errors.comunhaoNoivo ? ' error' : ''}`}>
                          <option value="">Selecione</option>
                          <option value="Sim">Sim</option>
                          <option value="Não">Não</option>
                        </select>
                        {errors.comunhaoNoivo && <p className="form-error">{errors.comunhaoNoivo}</p>}
                      </div>
                    </div>

                    {/* Coluna Noiva */}
                    <div>
                      <p style={{ fontWeight: 700, color: 'var(--navy)', marginBottom: 'var(--space-md)', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>👤 Noiva</p>
                      <div className="form-group">
                        <label className="form-label">Nome Completo <span className="required">*</span></label>
                        <input name="nomeNoiva" value={form.nomeNoiva} onChange={handleChange}
                          className={`form-input${errors.nomeNoiva ? ' error' : ''}`} />
                        {errors.nomeNoiva && <p className="form-error">{errors.nomeNoiva}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Telefone / WhatsApp <span className="required">*</span></label>
                        <input name="telefoneNoiva" value={form.telefoneNoiva} onChange={handleChange}
                          placeholder="(85) 99000-0000"
                          className={`form-input${errors.telefoneNoiva ? ' error' : ''}`} />
                        {errors.telefoneNoiva && <p className="form-error">{errors.telefoneNoiva}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Endereço <span className="required">*</span></label>
                        <input name="enderecoNoiva" value={form.enderecoNoiva} onChange={handleChange}
                          className={`form-input${errors.enderecoNoiva ? ' error' : ''}`} />
                        {errors.enderecoNoiva && <p className="form-error">{errors.enderecoNoiva}</p>}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Possui Primeira Comunhão? <span className="required">*</span></label>
                        <select name="comunhaoNoiva" value={form.comunhaoNoiva} onChange={handleChange}
                          className={`form-select${errors.comunhaoNoiva ? ' error' : ''}`}>
                          <option value="">Selecione</option>
                          <option value="Sim">Sim</option>
                          <option value="Não">Não</option>
                        </select>
                        {errors.comunhaoNoiva && <p className="form-error">{errors.comunhaoNoiva}</p>}
                      </div>
                    </div>
                  </div>

                  {/* Data do casamento */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Data do Casamento</h4>
                  <div style={{ maxWidth: 280, marginBottom: 'var(--space-lg)' }}>
                    <div className="form-group" style={{ margin: 0 }}>
                      <label className="form-label">Data prevista <span style={{ color: 'var(--gray-400)', fontWeight: 400 }}>(opcional)</span></label>
                      <input type="date" name="dataCasamento" value={form.dataCasamento} onChange={handleChange} className="form-input" />
                    </div>
                  </div>

                  {/* Documentos */}
                  <h4 style={{ color: 'var(--navy)', marginBottom: 'var(--space-md)', paddingBottom: '0.5rem', borderBottom: '2px solid var(--gold-pale)' }}>Documentos e Comprovante</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 'var(--space-md)', marginBottom: 'var(--space-md)' }}>
                    <FileUpload label="Documento do Noivo" required accept=".pdf,.jpg,.jpeg,.png"
                      error={errors.docNoivo} onChange={(f) => setFiles(v => ({ ...v, docNoivo: f }))} />
                    <FileUpload label="Documento da Noiva" required accept=".pdf,.jpg,.jpeg,.png"
                      error={errors.docNoiva} onChange={(f) => setFiles(v => ({ ...v, docNoiva: f }))} />
                  </div>
                  <div className="alert alert-info" style={{ marginBottom: '0.75rem' }}>
                    <strong>Taxa:</strong> R$ 150,00 por casal. Realize o pagamento e anexe o comprovante abaixo. A chave Pix é: 07.210.925/0024-00 (Mitra Arquidiocesana de Fortaleza). <br />
                  </div>
                  <FileUpload label="Comprovante de Pagamento (R$ 150,00)" required accept=".pdf,.jpg,.jpeg,.png"
                    error={errors.comprovante} onChange={(f) => setFiles(v => ({ ...v, comprovante: f }))} />

                  <div className="submit-row" style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 'var(--space-lg)', borderTop: '1px solid var(--gray-200)', marginTop: 'var(--space-lg)' }}>
                    <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                      {loading ? 'Enviando...' : '💍 Enviar Inscrição'}
                    </button>
                  </div>
                </form>
              </div>
            </>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Noivos;